export default {
  namespaced: true,
  state: {
    notifications: [],
    webhookData: null,
  },
  getters: {
    getNotifications: state => state.notifications,
  },
  mutations: {
    SET_NOTIFICATIONS(state, payload) {
      state.notifications.push(payload)
    },
    SET_WEBHOOK_DATA(state, payload) {
        state.webhookData = payload
    },
  },
  actions: {},
}
